import Mock from "../mock";

const database = {
    information: {
        name: 'home.name',
        aboutContent: "home.content",
        age: 26,
        phone: '',
        nationality: '',
        language: 'Italiano, Inglese, Tedesco',
        email: 'musarellaluca@gmail.com',
        address: '',
        profiles: 'Full Stack Web Developer',
        seniority: 'Middle/Junior',
        freelanceStatus: 'Lynx Group',
        linkCompany: 'https://www.lynxspa.com/sito/index_int.html?it',
        socialLinks: {
            linkedin: 'https://www.linkedin.com/in/luca-musarella-942545149/',
            github: 'https://github.com/lmusarella'
        },
        brandImage: '/images/luca-musarella.jpg',
        flagImage: '/images/gb.svg',
        aboutImage: '/images/luca-musarella.jpg',
        aboutImageLg: '/images/about-image-lg.jpg',
        cvfile: 'cv.cvfile',
        expFile: '/files/Luca_Musarella_Esperienza_Jac.pdf'
    },
    services: [
        {
            title: "whoiam.web_des_title",
            icon: 'color-pallet',
            details: "whoiam.web_design_desc"
        },
        {
            title: "whoiam.web_dev_title",
            icon: 'code',
            details: "whoiam.web_dev_desc"
        },
        {
            title: "whoiam.responsivness",
            icon: 'mobile',
            details: "whoiam.mob_dev_desc"
        }
    ],
    interessi: [
        {
            title: "whoiam.pol_title",
            details: "whoiam.pol_desc"
        },
        {
            title: "whoiam.investments_title",
            details: "whoiam.investments_desc"
        },
        {
            title: "whoiam.crypto_title",
            details: "whoiam.crypto_desc"
        },
    ],
    reviews: [],
    skills: [
        {
            title: "Typescript",
            value: 90
        },
        {
            title: "Javascript",
            value: 90
        },
        {
            title: "Java",
            value: 80
        },
        {
            title: "SQL",
            value: 70
        },
        {
            title: "Python",
            value: 45
        }
    ],
    frameworks: [
        {
            title: "Angular",
            value: 90
        },
        {
            title: "AngularJS",
            value: 70
        },
        {
            title: "Spring",
            value: 50
        },
        {
            title: "Hibernate",
            value: 40
        }
    ],
    os: [
        {
            title: "Windows",
            value: 90
        },
        {
            title: "Linux",
            value: 70
        }
    ],
    altro: [
        {
            title: "HTML5",
            value: 90
        },
        {
            title: "CSS3",
            value: 90
        },
        {
            title: "NgRx",
            value: 80
        },
        {
            title: "RxJs",
            value: 80
        }
    ],
    softskils: [
        {
            title: "Capacità di comunicazione",
            value: 90
        },
        {
            title: "Capacità di adattamento",
            value: 90
        },
        {
            title: "Gestione della pressione",
            value: 80
        },
        {
            title: "Capacità di problem solving",
            value: 85
        },
        {
            title: "Capacità di lavorare in team",
            value: 90
        },
        {
            title: "Capacità di leadership",
            value: 70
        },
        {
            title: "Etica lavorativa",
            value: 90
        },
        {
            title: "Empatia e Umorismo",
            value: 90
        }
    ],
    portfolios: [],
    experience: {
        workingExperience: [
            {
                id: 1,
                year: "cv.workexplist.year1",
                position: "cv.workexplist.position1",
                company: "cv.workexplist.company1",
                details: "cv.workexplist.details1"
            },
            {
                id: 2,
                year: "cv.workexplist.year2",
                position: "cv.workexplist.position2",
                company: "cv.workexplist.company2",
                details: "cv.workexplist.details2"
            },
            {
                id: 3,
                year: "cv.workexplist.year3",
                position: "cv.workexplist.position3",
                company: "cv.workexplist.company3",
                details: "cv.workexplist.details3"
            },
            {
                id: 4,
                year: "cv.workexplist.year4",
                position: "cv.workexplist.position4",
                company: "cv.workexplist.company4",
                details: "cv.workexplist.details4"
            }
        ],
        educationExperience: [
            {
                id: 1,
                year: "cv.studieslist.year1",
                graduation: "cv.studieslist.graduation1",
                university: "cv.studieslist.university1",
                details: "cv.studieslist.details1"
            },
            {
                id: 2,
                year: "cv.studieslist.year2",
                graduation: "cv.studieslist.graduation2",
                university: "cv.studieslist.university2",
                details: "cv.studieslist.details2"
            },
            {
                id: 3,
                year: "cv.studieslist.year3",
                graduation: "cv.studieslist.graduation3",
                university: "cv.studieslist.university3",
                details: "cv.studieslist.details3"
            }
        ]
    },
    blogs: [
        {
            id: 1,
            title: 'Freestyle Match Ranking App',
            featuredImage: '/images/bigfoot_battle_img.png',
            filesource: '../../blog/bigfoot_ranking_app.md'
        },
        {
            id: 1,
            title: 'Top Dance Academy',
            featuredImage: '/images/tda.png',
            filesource: '../../blog/top_dance_academy.md'
        },
        {
            id: 1,
            title: 'Java Game 2D',
            featuredImage: '/images/java_game_2d.png',
            filesource: '../../blog/java_game_2d.md'
        },
        {
            id: 1,
            title: 'Minecraft Plugin',
            featuredImage: '/images/minecraft_plugin.png',
            filesource: '../../blog/minecraft_plugin.md'
        },
        {
            id: 1,
            title: 'PWA - Angular + NgRx + Firebase',
            featuredImage: '/images/app_angular_firebase.png',
            filesource: '../../blog/app_angular_firebase.md'
        },
        {
            id: 1,
            title: 'PancakeSwap Prediction Game Bot',
            featuredImage: '/images/pancakeswap-bot.png',
            filesource: '../../blog/pancakeswap-bot.md'
        }
    ],
    progetti: [
        {
            id: 1,
            title: 'companyportfolio.title1',
            featuredImage: '/images/sanita_sfondo.jpeg',
            filesource: '../../blog/fornitori_gare_appalto.md'
        },
        {
            id: 1,
            title: 'companyportfolio.title2',
            featuredImage: '/images/energia_utility.jpeg',
            filesource: '../../blog/monitoraggio.md'
        },
        {
            id: 1,
            title: 'companyportfolio.title3',
            featuredImage: '/images/finance_banca.jpeg',
            filesource: '../../blog/sportello_bancario.md'
        },
        {
            id: 1,
            title: 'companyportfolio.title4',
            featuredImage: '/images/dashboard_sla.jpg',
            filesource: '../../blog/dashboard_sla.md'
        },
        {
            id: 1,
            title: 'companyportfolio.title5',
            featuredImage: '/images/cessione_credito.png',
            filesource: '../../blog/cessione_credito.md'
        },
    ],
    contactInfo: {
        phoneNumbers: [],
        emailAddress: ['musarellaluca@gmail.com', 'luca.musarella@lynxspa.com'],
        address: "Milano"
    }
};


Mock.onGet("/api/information").reply(config => {
    const response = database.information;
    return [200, response];
});

Mock.onGet("/api/services").reply(config => {
    const response = database.services;
    return [200, response];
});

Mock.onGet("/api/reviews").reply(config => {
    const response = database.reviews;
    return [200, response];
});

Mock.onGet("/api/skills").reply(config => {
    const response = database.skills;
    return [200, response];
});

Mock.onGet("/api/frameworks").reply(config => {
    const response = database.frameworks;
    return [200, response];
});

Mock.onGet("/api/os").reply(config => {
    const response = database.os;
    return [200, response];
});

Mock.onGet("/api/altro").reply(config => {
    const response = database.altro;
    return [200, response];
});

Mock.onGet("/api/softskils").reply(config => {
    const response = database.softskils;
    return [200, response];
});

Mock.onGet("/api/portfolios").reply(config => {
    const response = database.portfolios;
    return [200, response];
});

Mock.onGet("/api/experience").reply(config => {
    const response = database.experience;
    return [200, response];
});

Mock.onGet("/api/blog").reply(config => {
    const response = database.blogs;
    return [200, response];
});

Mock.onGet("/api/progetti").reply(config => {
    const response = database.progetti;
    return [200, response];
});

Mock.onGet("/api/contactinfo").reply(config => {
    const response = database.contactInfo;
    return [200, response];
});

Mock.onGet("/api/interessi").reply(config => {
    const response = database.interessi;
    return [200, response];
});
